module.exports = import("https://code.jquery.com/jquery-3.7.1.min.js");;